import { api } from "@/api/axios.ts";
import {
  ApiDocument,
  ApiDocumentSavePayload,
  ApiDocumentsFilter,
  ApiFolder,
  ApiFolderPayload,
  ApiFolderType,
} from "@/types/document.types.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";
import { ApiOperationResult } from "@/types/common.types.ts";

export const apiDocuments = {
  getAllFoldersByType: (folderType: ApiFolderType, signal?: AbortSignal) => {
    return api.get<ApiFolder[]>(`/api/v1/documents/folders/${folderType}`, undefined, signal);
  },
  createFolder: (payload: ApiFolderPayload) => {
    return api.post<ApiFolder>(`/api/v1/documents/folders`, payload);
  },
  updateFolder: (id: number, payload: ApiFolderPayload) => {
    return api.put<ApiFolder>(`/api/v1/documents/folders/${id}`, payload);
  },
  deleteFolder: (id: number) => {
    return api.delete(`/api/v1/documents/folders/${id}`);
  },

  getById: (id: number, signal?: AbortSignal) => {
    return api.get<ApiDocument>(`/api/v1/documents/${id}`, undefined, signal);
  },
  updateDocument: (id: number, payload: ApiDocumentSavePayload) => {
    return api.put<ApiDocument>(`/api/v1/documents/${id}`, payload);
  },
  deleteDocument: (id: number) => {
    return api.delete<ApiOperationResult>(`/api/v1/documents/${id}`);
  },
  searchDocuments: (filter: ApiDocumentsFilter, signal: AbortSignal) => {
    return api.post<ApiPagedData<ApiDocument>>(`/api/v1/documents/search`, filter, signal);
  },
  createDocumentForEmployee: (employeeId: number, payload: ApiDocumentSavePayload) => {
    return api.post<ApiDocument>(`/api/v1/documents/${employeeId}`, payload);
  },
  createDocumentForOrganization: (payload: ApiDocumentSavePayload) => {
    return api.post<ApiDocument>(`/api/v1/documents`, payload);
  },
};
